import defaultLabelStudioSettings from './data/defaultLabelStudioSettings.json'

export const overrideLabelStudioSettings = (_type: string) => {
  const settingsKey = 'labelStudio:settings'
  let settings = localStorage.getItem(settingsKey)
  if (settings === null || settings === undefined) {
    settings = JSON.stringify(defaultLabelStudioSettings)
  }
  settings = settings.replaceAll('"showLabels":true', '"showLabels":false')
  localStorage.setItem(settingsKey, settings)
}
